import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="mb-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider">分类浏览</span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
          探索<span className="text-primary-400">内容</span>类型
        </h2>
        <p className="text-foreground-400 text-sm mt-2">八大分类，满足你的每一种观影偏好</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 border border-background-200/30 rounded-lg hover:border-primary-500/30 hover:bg-background-200/30 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-500/10 rounded-lg group-hover:bg-primary-500/20 transition-colors duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-400 group-hover:text-primary-300`}></i>
            </div>
            <div className="text-center">
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.count}部作品</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}